// extracted by mini-css-extract-plugin
export var button = "donations-module--button--9c7fc";
export var container = "donations-module--container--d1545";
export var quote = "donations-module--quote--8b6e9";
export var text = "donations-module--text--1edcb";
export var title = "donations-module--title--13d8a";